import styled from "styled-components"
import Card from "@irati/ui/src/Layout/Card"
import media from "@irati/ui/src/global/media"

export default styled(Card)`
  margin-top: 150px;
  ${media.tablet`margin-top: 120px;`}
`
